import React, { useEffect, useState } from 'react'
import {
  Box,
  Flex,
  FormControl,
  Input,
  Switch,
  Text,
  Textarea,
} from '@chakra-ui/react'
import CustomFormLabel from '../../../components/ui/CustomFormLabel'
import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'

const SetupMetadata = observer(() => {
  const {
    wizardStore: {
      metadata,
      setReportTitle,
      setMetadata,
      setError,
      setCanGenerate,
    },
  } = rootStore

  useEffect(() => {
    setError(true)
  }, [setError])
  const [reportName, _setReportName] = useState('')

  let setReportName = value => {
    setReportTitle(value)
    _setReportName(value)
  }

  const handleChange = e => {
    setMetadata({
      ...metadata,
      [e.target.name]: e.target.value,
    })

    if (e.target.name === 'reportName') {
      setReportName(e.target.value)
      // If reportName is set (not empty), set error to false.
      // Otherwise, check if any other fields are empty.
      if (e.target.value.trim() !== '') {
        setCanGenerate(true)
      } else {
        setCanGenerate(false)
      }
    } else {
      setError(false)
    }
  }

  return (
    <Box>
      <CFormControl>
        <CustomFormLabel>
          Name of this report{' '}
          <HelperText>
            By convention: [ClientName] - [ProductName] [DataYear] -
            [DateIssued]
          </HelperText>
        </CustomFormLabel>
        <Input
          name="reportName"
          value={reportName}
          onChange={handleChange}
        />
      </CFormControl>
      <CFormControl>
        <CustomFormLabel>
          Short Description{' '}
          <HelperText>
            Will be displayed as subheader in the overview page. Max 100
            characters.
          </HelperText>
        </CustomFormLabel>
        <Input
          name="shortDescription"
          value={metadata.shortDescription}
          onChange={handleChange}
        />
      </CFormControl>
      <CFormControl>
        <CustomFormLabel>
          CEM internal note
          <HelperText>Any notes for you and other analysts</HelperText>
        </CustomFormLabel>
        <Textarea
          name="internalNotes"
          value={metadata.internalNotes}
          onChange={handleChange}
        />
      </CFormControl>
      <CFormControl>
        <CustomFormLabel>Status</CustomFormLabel>
        <HelperText ml={0}>
          Only 'approved' reports are visible to clients
        </HelperText>
        <Flex
          alignItems="center"
          mt="12px">
          <SwitchLabel>In Progress</SwitchLabel>
          <Switch
            name="status"
            m="0 8px"
            onChange={handleChange}
          />
          <SwitchLabel>Approved</SwitchLabel>
        </Flex>
      </CFormControl>
    </Box>
  )
})

const CFormControl = props => (
  <FormControl
    {...props}
    mb="16px"
  />
)

const HelperText = props => (
  <Text
    as="span"
    ml="6px"
    {...props}
    fontSize="14px"
    color="brand.textGray"
  />
)

const SwitchLabel = props => (
  <Text
    fontWeight="bold"
    fontSize="14px"
    color="brand.blue"
    {...props}
  />
)

SetupMetadata.propTypes = {}

export default SetupMetadata
